import React, { Component } from "react";
import { emitCasinoError } from "../utils/postMessageBridge";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    emitCasinoError(error?.message || "Unknown error");
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <section
          role="alert"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "60vh",
            padding: "2rem",
            textAlign: "center",
            fontFamily: "inherit",
          }}
        >
          <h2 style={{ marginBottom: "0.5rem", fontSize: "1.25rem" }}>
            Something went wrong
          </h2>
          <p style={{ color: "#666", marginBottom: "1.5rem" }}>
            An unexpected error occurred. Please try reloading.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: "0.625rem 1.5rem",
              fontSize: "1rem",
              cursor: "pointer",
              border: "none",
              borderRadius: "4px",
              backgroundColor: "#007bff",
              color: "#fff",
              minWidth: "44px",
              minHeight: "44px",
            }}
          >
            Reload
          </button>
        </section>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
